<template>
  <div>
    <div class="box">
      <loading v-if="isLoading" />

      <div v-if="!isLoading">
        <h2 class="title has-text-primary">
          <fa-icon class="margin-right-1" :icon="faChartPie" />Reporting
        </h2>

        <div class="columns">
          <div class="column is-narrow">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">Start</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="input" :class="{'is-danger' : $v.$dirty && $v.dateTimeFrom.$anyError}">
                      <datetime type="datetime" v-model="$v.dateTimeFrom.$model" :phrases="dateTimePhrases" />
                    </div>
                  </div>
                  <p class="help is-danger" v-if="$v.$dirty && !$v.dateTimeFrom.required">{{$v.dateTimeFrom.$params.required.msg}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-narrow">
            <div class="field is-horizontal">
              <div class="field-label is-normal">
                <label class="label">End</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <div class="input" :class="{'is-danger' : $v.$dirty && $v.dateTimeTo.$anyError}">
                      <datetime type="datetime" v-model="$v.dateTimeTo.$model" :phrases="dateTimePhrases" />
                    </div>
                  </div>
                  <p class="help is-danger" v-if="$v.$dirty && !$v.dateTimeTo.required">{{$v.dateTimeTo.$params.required.msg}}</p>
                  <p class="help is-danger" v-if="$v.$dirty && !$v.dateTimeTo.mustBeAfterFromDate">{{$v.dateTimeTo.$params.mustBeAfterFromDate.msg}}</p>
                  <p class="help is-danger" v-if="$v.$dirty && !$v.dateTimeTo.cannotBeAfterToday">{{$v.dateTimeTo.$params.cannotBeAfterToday.msg}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="column">
            <custom-button modifier="primary" :icon="faDownload" iconPosition="left" @click="submitExport" :disabled="$v.$invalid">Export</custom-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loading from "@/components/loading"
import customButton from "@/components/custom-button"
import { faChartPie, faDownload } from "@fortawesome/free-solid-svg-icons"
import { withParams } from 'vuelidate';
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    loading,
    customButton
  },
  data() {
    return {
      isLoading: false,
      faChartPie,
      faDownload,
      dateTimeFrom: this.$moment().subtract(1, 'month').format(),
      dateTimeTo: this.$moment().format(),
      dateTimePhrases: {
        ok: "OK",
        cancel: "Cancel"
      }
    }
  },
  methods: {
    submitExport() {
      this.$v.$touch();

      if (this.$v.$invalid)
        return;

      this.isLoading = true;

      var data = {
        startDate: this.dateTimeFrom,
        endDate: this.dateTimeTo
      };

      this.$http({
        url: 'timesheet/export-data',
        method: 'POST',
        data: data,
        responseType: 'blob',
      }).then((response) => {
        var fileLink = document.createElement('a');
        var fileName = 'Timesheets ' + this.$moment(this.dateTimeFrom).format('DD-MM-YYYY HH-mm') + ' - ' + this.$moment(this.dateTimeTo).format('DD-MM-YYYY HH-mm') + '.csv';

        fileLink.href = window.URL.createObjectURL(new Blob([response.data]));
        fileLink.setAttribute('download', fileName);
        document.body.appendChild(fileLink);

        fileLink.click();
        this.isLoading = false;
        this.$alert("The data was successfully exported. Your download should begin shortly.", "", "success");
      }).catch(() => {
        this.isLoading = false;
        this.$alert("An error occurred exporting the data.", "", "error");
      });
    }
  },
  validations: {
    dateTimeFrom: {
      required: withParams({ msg: "Please select a start date." }, required),
    },
    dateTimeTo: {
      required: withParams({ msg: "Please select an end date." }, required),
      mustBeAfterFromDate: withParams({ msg: "The end date must be after the start date." }, (value, vm) => (value > vm.dateTimeFrom)),
      cannotBeAfterToday: withParams({ msg: "The end date must be no later than now." }, (value, vm) => (vm.$moment(value) <= vm.$moment()))
    }
  }
}
</script>

<style lang="sass">
.vdatetime
  width: 100%
.vdatetime-input
  border: 0
  width: 100%
</style>